<template>
    <main>
        <div class="container-fluid">
             <div class="mainButton">
                <div class="row">
                    <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-end">
                        <DownloadAction v-if="downloadAction" ref="loaddownload"></DownloadAction>
                    </div>
                </div>
             </div>
             <div class="page-toolbar">
                <div class="page-title">
                    <span class="title">Detail Branch</span> 
                    <span class="star"> <i class="fa-solid fa-star"></i></span>
                </div>
            </div>
        </div>

      
        <GenericDetail v-if="generic" ref="loadGeneric"> </GenericDetail>
        <CustomDetail v-else></CustomDetail>
       
        <GenericMoreButton v-if="genericBtn" ref="loadgenericbtn"></GenericMoreButton>
        <CustomMoreButton v-else></CustomMoreButton>

    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Branchs/MenuList.vue";
    import lang from "@/views/modules/Branchs/language/en";
    import GenericDetail from "@/components/layout/shared/generic/DetailView.vue";
    import GenericMoreButton from "@/components/layout/shared/generic/common/MoreButton.vue";
    import CustomMoreButton from "@/views/modules/Branchs/MoreButton.vue";
    import DownloadAction from "@/components/layout/shared/generic/download/Download.vue";
    import CustomDetail from "@/views/modules/Branchs/DetailView.vue";

    export default {
        name: "new-branch",
        components: {
            breadcrumbs,
            GenericDetail,
            CustomMoreButton,
            GenericMoreButton,
            DownloadAction,
            CustomDetail
        },
        data() {
            return {
                generic: false,
                genericBtn:true,
                lang: [],
                metaList: [
                    {
                        name: 'col1',
                        items: [
                            {
                                name: 'name',
                                label: lang.LBL_BRANCH_NAME,
                                link: false,
                            },
                            {
                                name: 'branch_code',
                                label: lang.LBL_BRANCH_CODE,
                                link: true,
                            },
                            {
                                name: 'tenant_id',
                                label: lang.LBL_TENANT_ID,
                                link: false,
                            },
                            {
                                name: 'default_branch',
                                label: lang.LBL_DEFAULT_BRANCH,
                                link: false,
                                routePath: '',
                                checkboxtype: true
                            },
                        ]
                    },
                    {
                        name: 'col2',
                        items: [
                            {
                                name: 'ip_address',
                                label: lang.LBL_IPADDRESS,
                                link: false,
                            },
                            {
                                name: 'upload_path',
                                label: lang.LBL_UPLOAD_DIR,
                                link: false,
                            },
                            {
                                name: 'status',
                                label: lang.LBL_STATUS,
                                link: false,
                            },
                        ]
                    },
                    {
                        name: 'col3',
                        items: [
                            {
                                name: 'for_mobileapp',
                                label: lang.LBL_SHOW_MOBILE_APP,
                                checkboxtype: true
                            },
                            {
                                label:lang.LBL_BRANCH_TIMEZONE,
                                link:false,
                                name:'time_zone'
                            },
                        ]
                    },
                    {
                        name: 'col4',
                        items: [
                            {
                                name: 'date_entered',
                                label: lang.LBL_CREATE_DATE,
                                link: false,
                                routePath: ''
                            },
                            {
                                name: 'date_modified',
                                label: lang.LBL_MODIFIED_DATE,
                                link: false,
                                routePath: ''
                            },
                        ]
                    },
                    {
                        name: 'col4',
                        items: [
                            {
                                name: 'description',
                                label: lang.LBL_DESCRIPTION,
                                link: false,
                            },
                        ]
                    }
                ],
                moreBtn: [
                    {
                        id: 'edit',
                        path: 'branchs',
                        label: lang.LBL_EDIT,
                        action:'edit',
                    },
                    {
                        id: 'delete',
                        path: 'branchs',
                        label: lang.LBL_DELETE,
                        action:'delete',
                    },
                    
                ],
                routePath: {
                    path: 'branchs',
                    detail: false
                },
                 
                downloadAction:false,
                dowlloadList:[
                    {
                        label: lang.LBL_DOWNLOAD_ONE,
                        action:"",
                        module:"",
                    },
                    {
                        label: lang.LBL_DOWNLOAD_TWO,
                        action:"",
                        module:"",
                    }
                ]
            }
        },
        mounted() {
            this.childMethod();
            this.lang = lang;
            this.showdowmload();
        },
        methods: {
            childMethod() {
                if(this.generic == true){
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
                if(this.genericBtn == true){
                    this.$refs.loadgenericbtn.loadGenericBtn(this.moreBtn);
                }
            },
            showdowmload(){
                const self = this;
                if(self.downloadAction == true){
                    this.$refs.loaddownload.loadDownloadView(self.dowlloadList);
                }
            }
        }
    }

</script>
